import { Cr } from "@cimo/request/dist/src/Main";

// Source
import StorePreference from "../store/Preference";
import * as ModelPreference from "../model/Preference";
import * as HelperSrc from "../HelperSrc";
import * as ModelHelperSrc from "../model/HelperSrc";

export const api = new Cr(`${HelperSrc.URL_BACKEND || ""}`, HelperSrc.REQUEST_TIMEOUT, HelperSrc.REQUEST_IS_ENCODED);

api.setRequestInterceptor((config) => {
    return requestLogic(config);
});

api.setResponseInterceptor((response: Response) => {
    return responseLogic(response);
});

const requestLogic = (config: RequestInit): RequestInit => {
    const storePreference: ModelPreference.Istore<ModelPreference.Idata> = new StorePreference();
    const storagePreferenceData = storePreference.storageGet();

    return {
        ...config,
        headers: {
            ...config.headers,
            "Accept-Language": storagePreferenceData ? storagePreferenceData.language : ""
        },
        credentials: "include"
    };
};

const responseLogic = (response: Response) => {
    if (response.status === 403) {
        response
            .json()
            .then((result: ModelHelperSrc.Iresponse) => {
                alert(result.message.error);
            })
            .catch((error: Error) => {
                HelperSrc.writeLog("error", error.message);
            });
    } else if (response.status === 500) {
        alert(response.status);

        HelperSrc.writeLog("error", response.status.toString());
    }

    return response;
};
